import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations, getNestedValue } from '../i18n/translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('love4vegan_language');
    return saved || 'fi'; // Finnish as default
  });

  useEffect(() => {
    localStorage.setItem('love4vegan_language', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    const value = getNestedValue(translations[language], key);
    return value || key;
  };

  const getLocalizedText = (textObj) => {
    if (!textObj) return '';
    if (typeof textObj === 'string') return textObj;
    return textObj[language] || textObj.en || textObj.fi || '';
  };

  const value = {
    language,
    setLanguage,
    t,
    getLocalizedText,
    languages: [
      { code: 'fi', name: 'Suomi', flag: '🇫🇮' },
      { code: 'fr', name: 'Français', flag: '🇫🇷' },
      { code: 'en', name: 'English', flag: '🇬🇧' }
    ]
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
